import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { IntervenantsService } from '../../services/intervenants.service';
import { IntervenantResponse } from '../../interfaces/intervenant-type.interface';

export const intervenantsResolver: ResolveFn<IntervenantResponse> = (
  // route: ActivatedRouteSnapshot
) => {
  // const numDossier = route.paramMap.get('numDossier');
  return inject(IntervenantsService).getIntervenants()
};
